import React, { useEffect, useState } from 'react';
import { GeoJSON } from 'react-leaflet';
import { getGeometryLayerRequestPath } from '../../config/geometry-layer-urls';
import { apiGet } from '../../apiHelpers';
import { useDisplayPreferences } from '../../displayPreferences-context';
export function FloodBoundaryLayer() {
    const [boundaryGeojson, setBoundaryGeojson] = useState(null);
    const { flood } = useDisplayPreferences();
    useEffect(() => {
        apiGet(getGeometryLayerRequestPath('flood'))
            .then(data => {
            if (data && data.type === 'FeatureCollection') {
                setBoundaryGeojson(data);
            }
            else {
                setBoundaryGeojson(null);
            }
        })
            .catch(() => setBoundaryGeojson(null));
    }, []);
    if (flood == "enabled") {
        return boundaryGeojson &&
            React.createElement(GeoJSON, { attribution: 'Flood zone from <a href=https://data.london.gov.uk/dataset/flood-risk-zones>London Datastore</a>: \u00A9 Environment Agency copyright and/or database right 2017. All rights reserved. Some features of this map are based on digital spatial data from the Centre for Ecology & Hydrology, \u00A9 NERC (CEH) \u00A9 Crown copyright and database rights 2017 Ordnance Survey 100024198', data: boundaryGeojson, style: { color: '#00f', fill: true, weight: 1, opacity: 0.6 } });
    }
    else if (flood == "disabled") {
        return React.createElement("div", null);
    }
}
